<template>
    <div class="section row clearfix topmargin">
        <div class="col-md-12">
            <div v-if="loaded === false" class="ml-3">
                <b-spinner small></b-spinner>&nbsp;Loading members...
            </div>
            <member-list :items="termed" title="Pending Terms" v-if="termed.length > 0" display-terms="true">
                <b-button variant="secondary" @click="reinstateUser(data)">Reinstate</b-button>
            </member-list>
            <div v-if="loaded && termed.length === 0">
                <h2>Pending Terms</h2>
                <p>Currently there are no members awaiting termination.</p>
            </div>
        </div>
    </div>
</template>

<script>
    import MemberList from '../../../components/Dashboard/MemberList'
    import { mapGetters, mapActions } from 'vuex'
    import config from '@/config/config'
    import axios from 'axios'

    export default {
        name: 'PendingTerms',
        components: {MemberList},
        data () {
            return {
                termed: [],
                loaded: false
            }
        },
        computed: {
            ...mapGetters(['currentMember']),
        },
        methods: {
            ...mapActions(['getMemberData']),
            pending () {
                this.loaded = false
                let tempTermed = localStorage.getItem('tempTermed')
                if (tempTermed !== '') {
                    let membership = []
                    tempTermed = tempTermed ? tempTermed.split(',') : []
                    tempTermed.forEach(termed => {
                        axios.get(config.apiUrl() + 'member/' + termed).then(response => {
                            this.termed.push(response.data)
                            this.loaded = true
                        }, err => {
                            this.loaded = false
                        })
                    })
                }
            },
            reinstateUser (data) {
                let payload = {
                    cert: data.item.cert,
                    groupCode: data.item.underwriter + data.item.group
                }
                axios.post(config.apiUrl() + 'member/reinstate/' + data.item.cert, payload).then(response => {
                    if (response.data.msg === 'ok') {
                        let tempTermed = localStorage.getItem('tempTermed')
                        tempTermed = tempTermed ? tempTermed.split(',') : []
                        this.items.splice(data.index, 1)
                        tempTermed.splice(data.index, 1)
                        localStorage.setItem('tempTermed', tempTermed.toString())
                    } else {
                        this.termError = response.data.msg
                    }
                }, err => {
                    this.termError = err
                })
            }
        },
        beforeMount () {
            this.pending()
        }
    }
</script>

<style scoped>

</style>
